export default "__VITE_ASSET__BHvwk8rV__"